export default "__VITE_ASSET__PJs4rPRD__"